<form [formGroup]="form" (ngSubmit)="save()">
  <!-- HEADER -->
  <div class="modal-header">
    <h4 class="modal-title">Add Pickup Location</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="cancel()"
    ></button>
  </div>

  <div class="modal-body p-0 bst-pickup-location-form">
    <!-- ADDRESS TYPE -->
    <div
      class="pt-3 pb-3 ps-4 pe-4"
      [ngClass]="orderData?.type === 'part-load-door' ? 'd-none' : 'd-block'"
    >
      <div class="d-flex row mb-3">
        <div class="col-lg-4">
          <input
            class="btn-check"
            type="radio"
            id="type-customer"
            value="Customer Address"
            formControlName="type"
            (change)="onTypeChange('Customer Address')"
          />
          <label
            for="type-customer"
            class="service-option flex-fill p-3 rounded-xl d-block"
            [class.active]="form.get('type')?.value === 'Customer Address'"
          >
            <div class="font-extrabold text-body1">Customer Address</div>
          </label>
        </div>

        <div class="col-lg-4">
          <input
            class="btn-check"
            type="radio"
            id="type-godown"
            value="BST Godown Address"
            formControlName="type"
            (change)="onTypeChange('BST Godown Address')"
          />
          <label
            for="type-godown"
            class="service-option flex-fill p-3 rounded-xl d-block"
            [class.active]="form.get('type')?.value === 'BST Godown Address'"
          >
            <div class="font-extrabold text-body1">BST Godown Address</div>
          </label>
        </div>
      </div>
    </div>

    <hr />

    <!-- PICKUP -->
    <div class="pt-3 pb-3 ps-4 pe-4" formGroupName="pickup">
      <!-- ADDRESS -->
      <label class="form-label text-body1">
        Select Pickup location (Address) *
      </label>

      <ng-select
        placeholder="Select Location"
        formControlName="deliveryLocationId"
        [searchable]="true"
      >
        <ng-container *ngFor="let addr of addressList">
          <ng-option
            *ngIf="pickupLocationOptions.includes(addr?.city.toLowerCase())"
            [value]="addr.addressId"
          >
            <div class="user-name">
              <h5>{{ addr.companyName }}</h5>
            </div>
          </ng-option>
        </ng-container>
      </ng-select>

      <div
        class="text-danger small mt-1"
        *ngIf="
          pickupFG.get('deliveryLocationId')?.touched &&
          pickupFG.get('deliveryLocationId')?.invalid
        "
      >
        Pickup location is required
      </div>

      <!-- ITEMS -->
      <div formArrayName="items">
        <div
          class="row g-2 mb-3 mt-2 align-items-start justify-content-between flex-nowrap"
          *ngFor="
            let item of itemsFA.controls;
            let ii = index;
            trackBy: trackByIndex
          "
          [formGroupName]="ii"
        >
          <!-- PRODUCT -->
          <div class="col-lg-2">
            <label class="form-label text-body1">Select Product</label>
            <ng-select
              placeholder="Select"
              formControlName="productId"
              [searchable]="true"
            >
              <ng-option
                *ngFor="let product of productData"
                [value]="product._id"
              >
                <div class="user-name">
                  <h5>{{ product.name }}</h5>
                </div>
              </ng-option>
            </ng-select>

            <div
              class="text-danger small"
              *ngIf="
                item.get('productId')?.touched && item.get('productId')?.invalid
              "
            >
              Product is required
            </div>
          </div>

          <!-- SIZE -->
          <div class="col-lg-2">
            <label class="form-label text-body1">Size</label>
            <ng-select
              placeholder="Select"
              formControlName="subItemId"
              [items]="getSubItems(item.get('productId')?.value)"
              bindLabel="name"
              bindValue="_id"
              [clearable]="true"
            ></ng-select>

            <div
              class="text-danger small"
              *ngIf="
                item.get('subItemId')?.enabled &&
                item.get('subItemId')?.touched &&
                item.get('subItemId')?.invalid
              "
            >
              Size is required
            </div>
          </div>

          <!-- QUANTITY -->
          <div class="col-lg-3">
            <label class="form-label text-body1">Quantity (Box)</label>
            <input
              type="number"
              class="form-control text-body1"
              formControlName="quantityBox"
              min="1"
            />
            <div
              class="text-danger small"
              *ngIf="
                item.get('quantityBox')?.touched &&
                item.get('quantityBox')?.invalid
              "
            >
              Quantity is required
            </div>
          </div>

          <!-- WEIGHT -->
          <div class="col-lg-3">
            <label class="form-label text-body1">Weight (KG)</label>
            <input
              type="number"
              class="form-control text-body1"
              formControlName="weightKg"
              min="1"
            />
            <div
              class="text-danger small"
              *ngIf="
                item.get('weightKg')?.touched && item.get('weightKg')?.invalid
              "
            >
              Weight is required
            </div>
          </div>

          <!-- ACTION -->
          <div class="col-lg-2 d-flex flex-column">
            <label class="form-label text-body1">Action</label>
            <button
              *ngIf="itemsFA.length > 1"
              type="button"
              class="delete-btn rounded"
              (click)="removeItem(ii)"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7 21C6.45 21 5.97917 20.8042 5.5875 20.4125C5.19583 20.0208 5 19.55 5 19V6C4.71667 6 4.47917 5.90417 4.2875 5.7125C4.09583 5.52083 4 5.28333 4 5C4 4.71667 4.09583 4.47917 4.2875 4.2875C4.47917 4.09583 4.71667 4 5 4H9C9 3.71667 9.09583 3.47917 9.2875 3.2875C9.47917 3.09583 9.71667 3 10 3H14C14.2833 3 14.5208 3.09583 14.7125 3.2875C14.9042 3.47917 15 3.71667 15 4H19C19.2833 4 19.5208 4.09583 19.7125 4.2875C19.9042 4.47917 20 4.71667 20 5C20 5.28333 19.9042 5.52083 19.7125 5.7125C19.5208 5.90417 19.2833 6 19 6V19C19 19.55 18.8042 20.0208 18.4125 20.4125C18.0208 20.8042 17.55 21 17 21H7ZM10 17C10.2833 17 10.5208 16.9042 10.7125 16.7125C10.9042 16.5208 11 16.2833 11 16V9C11 8.71667 10.9042 8.47917 10.7125 8.2875C10.5208 8.09583 10.2833 8 10 8C9.71667 8 9.47917 8.09583 9.2875 8.2875C9.09583 8.47917 9 8.71667 9 9V16C9 16.2833 9.09583 16.5208 9.2875 16.7125C9.47917 16.9042 9.71667 17 10 17ZM14 17C14.2833 17 14.5208 16.9042 14.7125 16.7125C14.9042 16.5208 15 16.2833 15 16V9C15 8.71667 14.9042 8.47917 14.7125 8.2875C14.5208 8.09583 14.2833 8 14 8C13.7167 8 13.4792 8.09583 13.2875 8.2875C13.0958 8.47917 13 8.71667 13 9V16C13 16.2833 13.0958 16.5208 13.2875 16.7125C13.4792 16.9042 13.7167 17 14 17Z"
                  fill="#F04438"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <button
        type="button"
        class="btn-link btn-link-primary d-flex align-items-center text-body2 gap-1 p-0"
        (click)="addItem()"
      >
        ADD PRODUCT
      </button>
    </div>
  </div>

  <!-- FOOTER -->
  <div class="modal-footer">
    <button
      class="btn btn-primary"
      type="submit"
      [disabled]="isViewMode || form.invalid"
    >
      Save
    </button>
  </div>
</form>
